import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { distinctUntilChanged } from 'rxjs/operators';
import { of } from 'rxjs';

/**
 * An interface of a header table
 *
 * @export
 * @interface IHeaderConfig
 */
export interface IHeaderConfig {
  name: string
  isSortable?: boolean
  sortProperty?: string
  sorting?: (data: string) => boolean
  classes?: Array<string>;

  /**
   * Subheaders Array tha must be painted
   *
   * @type {Array<string>}
   * @memberof IHeaderConfig
   */
  subHeaders?:Array<string>;

  /**
   * Property that could be passes for set some action when clicked
   *
   * @memberof IHeaderConfig
   */
  subHeaderAction?: (data:string) => boolean

  /**
   * Property that could be passed for set some logic and customize classes
   *
   * @memberof IHeaderConfig
   */
  subHeadersClasses?:(data:string) => any
}


/**
 * A component that renders a list of headers
 *
 * @export
 * @class HeadersComponentComponent
 * @implements {OnInit}
 */
@Component({
  selector: '[app-headers-component]',
  templateUrl: './headers-component.component.html',
  styleUrls: ['./headers-component.component.scss']
})
export class HeadersComponentComponent implements OnInit {

  /**
   * The input of headers array
   *
   * @type {Array<IHeaderConfig>}
   * @memberof HeadersComponentComponent
   */
  @Input()
  headers: Array<IHeaderConfig>;

  /**
   * the input of the default sort if there's any (need to be implemented)
   *
   * @type {string}
   * @memberof HeadersComponentComponent
   */
  @Input()
  defaultSort: string;


  /**
   * The input of the function that performns the sorting action
   *
   * @memberof HeadersComponentComponent
   */
  @Input()
  isSortableFunc: (name: string) => string

  /**
   * The events emitter that is fired when a sort event is performend on click
   *
   * @memberof HeadersComponentComponent
   */
  @Output()
  changeSort = new EventEmitter();

  /**
   * The event emitter that is fire for an specific subheader
   *
   * @memberof HeadersComponentComponent
   */
  @Output()
  subHeaderAction = new EventEmitter();

  constructor(private translateService: TranslocoService) { }

  ngOnInit() {
    this.headers.forEach(value => {
      value.name = this.translateService.translate(value.name) !== this.translateService.getActiveLang() ?
        this.translateService.translate(value.name) : value.name;
    });
    this.headers.forEach(header=> {
      if(header.subHeadersClasses){
        header.subHeadersClasses.bind(this);
      }
    })
  }

  /**
   * The sort function that is binded to the view in the click
   *
   * @param {string} name
   * @memberof HeadersComponentComponent
   */
  sortClick(header: IHeaderConfig) {
    if (header.isSortable) {
      this.changeSort.emit(header.sortProperty);
    }
  }

  /**
   *
   *
   * @param {string} subHeader
   * @memberof HeadersComponentComponent
   */
  subHeaderClick(subHeader:string){
    this.subHeaderAction.emit(subHeader);
  }

  /**
   * Builds header classes.
   *
   * @param {IHeaderConfig} header
   *   Header.
   *
   * @returns Array<string>
   *   Classes.
   *
   * @memberof HeadersComponentComponent
   */
  createClass(header: IHeaderConfig) {
    const sort = this.isSortableFunc(header.sortProperty) ? this.isSortableFunc(header.sortProperty) : '';
    let classes = { 'asc': sort === 'asc', 'desc': sort === 'desc', 'wa-table__cell': true, 'sortable': header.isSortable };
    if (header.classes !== undefined) {
      for (var key in header.classes) {
        classes[header.classes[key]] = true;
      }
    }
    return classes;
  }

}
